import { Tooltip, Typography } from '@mui/material';

interface Props {
  notPresetCount: number;
  optionsCount: number;
  totalCount: number;
}

export function SelectedCountLabel({
  notPresetCount,
  optionsCount,
  totalCount,
}: Props) {
  return (
    <Typography sx={{ flexGrow: 1, fontWeight: 500 }} variant="modalContent">
      Selected:{' '}
      {notPresetCount > 0 ? (
        <Tooltip
          arrow
          placement="bottom"
          title={
            <Typography variant="caption">
              Some of the selected values are not present in the list.
            </Typography>
          }
        >
          <Typography
            sx={{
              fontWeight: 500,
              color: 'primary.main',
              textDecoration: 'underline',
              cursor: 'pointer',
              position: 'relative',
              pr: 0.625,
            }}
            component="span"
            variant="modalContent"
          >
            {Math.max(optionsCount - notPresetCount, 0)}
            <Typography
              component="sup"
              sx={{
                position: 'absolute',
                top: 0,
                right: 0,
                fontSize: '0.625rem',
              }}
            >
              ?
            </Typography>
          </Typography>
        </Tooltip>
      ) : (
        <Typography
          sx={{
            fontWeight: 500,
            color: 'primary.main',
          }}
          component="span"
          variant="modalContent"
        >
          {Math.max(optionsCount, 0)}
        </Typography>
      )}{' '}
      of {totalCount}
    </Typography>
  );
}
